import React, { useEffect, useState } from "react";
import { loadAll } from "./CriteriaService";
import { useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import { useParams, NavLink } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";

export default function SavedCriteriaList() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        const all = await loadAll();
        setRecords(all);
      } catch (err) {
        console.error("Failed to load saved criteria", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  return (
    <div className="row">
      <Navbar />
      <div className="col-md-10 mt-4">
        <h3>
          Saved Scoring Criteria
          <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
            Back to Company Log
          </NavLink>
        </h3>

        {loading && loading ? (
          <ShimmerTable row={5} col={4} />
        ) : (
          <table className="table table-bordered table-hover mt-3">
            <thead className="table-green">
              <tr>
                <th>#</th>
                <th>Save Name</th>
                <th>ID</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                records.map((doc, idx) => (
                  <tr key={doc._id}>
                    <td>{idx + 1}</td>
                    <td>{doc.saveName || "Untitled"}</td>
                    <td>{doc._id}</td>
                    <td>
                      <NavLink
                        to={`/ScoringCriteria/${doc._id}`}
                        className="btn btn-outline-primary btn-sm"
                      >
                        View
                      </NavLink>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No saved data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
